import { Link } from 'react-router-dom';

import styles from './NavLogo.module.scss';


export function NavLogo() {
	return (
		<Link to="/" className={ styles.logo } >
			{/* <span className={ styles.icon }>QRIP</span> */}
			{/* <Icon icon="icon-logo" className={ styles.icon } /> */}
			<img className={ styles.icon } src="/images/logo-cogs.svg" />
		</Link>
	);
}
